import SkillItem from "./skill_item";
import User from "../../../client/models/user";

export default class ExamGeneration {
    readonly id: string
    readonly examId: string
    readonly user: User
    readonly body: string
    readonly createdAt: string
    readonly updatedAt: string

    constructor(data: { [key: string]: any }){
        this.id = data.id
        this.examId = data.examId
        this.user = new User( data.user)
        this.body = data.body
        this.createdAt = data.createdAt
        this.updatedAt = data.updatedAt
    }
}